import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import "./select-options.styles.scss";
import { FrequenciaTipoEnum } from "../../../../enum/lancamento-aula/frequencia-tipo.enum";
import { TFunction } from "i18next";

interface PresencaSelectOptionProps {
  value: FrequenciaTipoEnum;
  t: TFunction<"gestao_de_aulas", undefined>
}

export default function PresencaSelectOption({
  value,
  t
}: PresencaSelectOptionProps) {
  const getPresencaOption = {
    PRE: {
      icon: <CheckCircleOutlined style={{ color: "var(--green-color)" }} />,
      text: t('gestao_de_aulas:present'),
      style: { color: "var(--green-color)" },
    },
    ATR: {
      icon: <ClockCircleOutlined style={{ color: "var(--orange-color)" }} />,
      text: t('gestao_de_aulas:late'),
      style: { color: "var(--orange-color)" },
    },
    AST: {
      icon: <CloseCircleOutlined style={{ color: "var(--red-color)" }} />,
      text: t('gestao_de_aulas:absent'),
      style: { color: "var(--red-color)" },
    },
  };

  const presencaOption = getPresencaOption[value];

  return (
    <div className={"select-options-wrapper"}>
      {presencaOption.icon}
      <p style={presencaOption.style}>{presencaOption.text}</p>
    </div>
  );
}
